import { render, staticRenderFns } from "./cbn.vue?vue&type=template&id=996636ba&scoped=true&"
import script from "./cbn.vue?vue&type=script&lang=js&"
export * from "./cbn.vue?vue&type=script&lang=js&"
import style0 from "./cbn.vue?vue&type=style&index=0&id=996636ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996636ba",
  null
  
)

export default component.exports